



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmDialog extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;
  @Prop({ default: 'Êtes-vous sûr ?' }) text: string;
  @Prop({ default: 'Confirmer' }) confirmText: string;
  @Prop({ default: 'Annuler' }) cancelText: string;
  @Prop({ default: 'Confirmer cette action' }) title: string;

  confirm() {
    this.$emit('confirm');
  }

  cancel() {
    this.$emit('cancel');
  }
}
